import React, { useState, useEffect } from "react";
import styles from "./TemplateHero26.module.css";

const TemplateHero26 = ({ branding, heroData }) => {
  const [current, setCurrent] = useState(0);
  const [tick, setTick] = useState(0);

  const slides = heroData?.slides || [];

  useEffect(() => {
    if (slides.length <= 1) return;

    const t = setInterval(() => {
      setCurrent((p) => (p + 1) % slides.length);
      setTick((p) => p + 1);
    }, 5000);

    return () => clearInterval(t);
  }, [slides.length]);

  if (!slides.length) return null;

  const visible = slides.slice(0, Math.min(4, slides.length));

  const cardPositions = [
    { top: "8%", left: "36%", width: "38%", height: "68%", zIndex: 4, rotate: "-1deg" },
    { top: "14%", left: "54%", width: "34%", height: "60%", zIndex: 3, rotate: "1.5deg" },
    { top: "20%", left: "68%", width: "30%", height: "52%", zIndex: 2, rotate: "-0.8deg" },
    { top: "26%", left: "78%", width: "26%", height: "44%", zIndex: 1, rotate: "1deg" },
  ];

  const tickerItems = [
    "Dubai","Paris","Bali","Tokyo","Maldives",
    "Santorini","New York","Rome","Sydney","Bangkok"
  ];

  const titleParts = slides[current].title.split(" ");

  return (
    <div className={styles.root}>
      <div className={styles.grid} />

      {/* LEFT TEXT BLOCK */}
      <div className={styles.left}>
        <div className={styles.issue}>
          {branding?.companyName || "Travel Gazette"} · Edition 0{current + 1}
        </div>

        <div className={styles.rule} />

        <h1 className={styles.headline} key={tick}>
          {titleParts.slice(0, 2).join(" ")}
          <span className={styles.accent}>
            {titleParts.slice(2).join(" ")}
          </span>
        </h1>

        <div className={styles.ruleThin} />

        <p className={styles.deck}>{slides[current].subtitle}</p>

        <div className={styles.actions}>
          <button className={styles.btnPrimary}>Book Now</button>
          <button className={styles.btnSecondary}>View All →</button>
        </div>

        <div className={styles.nav}>
          {slides.map((_, i) => (
            <div
              key={i}
              className={`${styles.navDot} ${i === current ? styles.active : ""}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>

      {/* CARDS */}
      {visible.map((s, i) => {
        const pos = cardPositions[i];
        const isActive = i === current % visible.length;

        return (
          <div
            key={i}
            className={styles.card}
            style={{
              backgroundImage: `url('${s.image}')`,
              top: pos.top,
              left: pos.left,
              width: pos.width,
              height: pos.height,
              zIndex: isActive ? pos.zIndex + 2 : pos.zIndex,
              transform: `rotate(${pos.rotate}) scale(${isActive ? 1.01 : 1})`
            }}
            onClick={() => setCurrent(i)}
          >
            <div className={styles.cardOverlay} />

            <div className={styles.cardNum}>0{i + 1}</div>

            <div className={styles.cardLabel}>
              <div className={styles.cardTag}>Destination</div>
              <div className={styles.cardTitle}>{s.title}</div>
            </div>
          </div>
        );
      })}

      {/* TICKER */}
      <div className={styles.ticker}>
        <div className={styles.tickerLabel}>Destinations</div>

        <div className={styles.tickerTrack}>
          {[...tickerItems, ...tickerItems].map((item, i) => (
            <span key={i} className={styles.tickerItem}>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TemplateHero26;